import { i18n } from '../i18n.js';
import { Confirm } from './confirm-dialog.js';

/**
 * THE ONE WARNING BOTH BATTLE SWITCHES SHARE.
 *
 * The owner asked for it on ANY switch, not just the new one: "when player
 * clicks on any swtich they get a warning". It lived inside the Lucid control
 * first, which left the manga switch — the one that has been costing Moonlight
 * the longest — silently free to arm itself.
 *
 * It fires when a switch is turned ON, once per session per switch. Confirming
 * on every toggle was rejected deliberately: a dialog the player dismisses
 * reflexively teaches them to stop reading it, which is worse than not warning
 * at all. Once, at the moment the choice first becomes real, is where it is
 * actually read.
 */

function uiText(key, fallback) {
    const translated = i18n?.t?.(key);
    return translated && translated !== key ? translated : fallback;
}

const WARNED = new Set();

export async function warnBeforeEnabling(kind) {
    if (WARNED.has(kind)) return true;
    const ok = await Confirm.ask(
        uiText('duelCost.warning.title', 'This option uses Moonlight faster.'),
        {
            detail: uiText(
                'duelCost.warning.detail',
                'Each duel costs more Moonlight. You can turn it off whenever you like.',
            ),
            confirmLabel: uiText('duelCost.warning.confirm', 'Turn it on'),
            cancelLabel: uiText('duelCost.warning.cancel', 'Leave it off'),
        },
    );
    if (ok) WARNED.add(kind);
    return ok;
}

/** Tests drive the once-per-session rule; nothing in the product calls this. */
export function resetDuelCostWarnings() {
    WARNED.clear();
}
